import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { acceptRejectCandidateMergeRequestType, MatchListType, MergeType } from '../../types/candidate';
import { CandidateMatchRequestType, CandidateMatchResponseType, CandidateStatusEnum } from '../../types/company';
import { companyService } from '../../lib/api/company';
import PageLoader from '../loader';
import { useAppSelector } from '../../redux/hooks';
import Swal from 'sweetalert2';
import { SuccessIcon } from '../../lib/utils/messages';
import { candidateService } from '../../lib/api/candidate';
import { mapPunchedByNameTextAndColor } from '../../containers/match-list/most-likely/mostLikelyMatchTable';

type Props = {
    show: boolean;
    handleClose: (key: boolean) => void;
    getListData: () => void;
    candidateData: MatchListType | null;
    showEventButton: boolean;
    matchType: number;
};

const MatchModal: React.FC<Props> = ({ show, handleClose, candidateData, showEventButton, matchType, getListData }) => {
    const [data, setData] = useState<CandidateMatchResponseType[]>();
    const [loading, setLoading] = useState(true);
    const [showSidebarTab, setShowSidebarTab] = useState(true);
    const [email, setEmail] = useState('');
    const [fullName, setFullName] = useState('');
    const { user } = useAppSelector((state) => state.user);
    const [userData, setUserData] = useState<CandidateMatchResponseType[]>([]);

    const [listCheckedMap, setListCheckedMap] = useState<{ [key: number]: boolean }>({});
    const [selectedRadioIndex, setSelectedRadioIndex] = useState<number | null>(null);

    const handleCloseModal = () => {
        handleClose(false);
        setUserData([]);
        setFullName('');
        setListCheckedMap({});
        setSelectedRadioIndex(null);
    };

    const emailArray = [
        'saikiran.potlapalli@wallero.com',
        'saikiran.potlapalli@offerx.net',
        'bujzi2898@outlook.com',
        'sohini.mukherjee@wallero.com',
        'Laxman.Puja@wallero.com',
        'Snigdha.Dutta@wallero.com',
    ];

    const AcceptRejectCandidateMerge = async (mergeType: MergeType) => {
        try {
            setLoading(true);
            if (candidateData) {
                const [firstName, lastName] = fullName.split(' ');

                const params: acceptRejectCandidateMergeRequestType = {
                    dataPunchId: candidateData?.dataPunchId,
                    parentCandidateId: candidateData?.candidateId,
                    childCandidateList: userData?.map((user) => ({
                        childCandidateId: user?.userId,
                        candidatePhone: user?.phone,
                        candidateEmail: user?.email,
                        candidateFirstName: firstName || '',
                        candidateLastName: lastName || '',
                    })),
                    mergeType: mergeType,
                };

                await candidateService.acceptRejectCandidateMerge(params);
                Swal.fire({
                    icon: SuccessIcon,
                    title: `Candidate match ${mergeType ? 'Rejected' : 'Accepted'} successfully`,
                    showConfirmButton: false,
                    timer: 1500,
                });

                handleCloseModal();
                getListData();
            }
        } catch (error) {
            console.log('candidateService updateFlag', error);
            handleCloseModal();
        } finally {
            setLoading(false);
        }
    };

    function isEmailInArray(email: string | undefined, array: string[]) {
        return array.indexOf(email?.toLowerCase() || '') !== -1;
    }

    useEffect(() => {
        if (isEmailInArray(user?.email, emailArray)) {
            setShowSidebarTab(false);
        } else {
            setShowSidebarTab(true);
        }
    }, [email]);

    const getList = useCallback(async () => {
        try {
            sessionStorage.clear();
            !loading && setLoading(true);
            const params: CandidateMatchRequestType = {
                matchType,
                email: candidateData?.email || '',
                fullName: candidateData?.candidateName || '',
                phoneNumber: candidateData?.phone || '',
                candidateId: candidateData?.candidateId || '',
            };

            const { resultObject } = await companyService.getCandidateMatchList(params);
            setData(resultObject);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [loading, candidateData]);

    useEffect(() => {
        if (candidateData) {
            (async function () {
                await getList();
            })();
        }
    }, [candidateData]);

    const isAnyChecked = Object.values(listCheckedMap).some((v) => v === true);


    return (
        <Modal size="lg" show={show} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>Match Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="fs-12 fw-600 mb-3">Existing Candidate:</div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="fs-12 fw-600">Name:</div>
                        <div className="fs-14 text-ellipsis">{candidateData?.candidateName || 'NA'}</div>
                    </div>
                    <div className="col-md-3">
                        <div className="fs-12 fw-600">Email:</div>
                        <div className="fs-14 text-ellipsis">{candidateData?.email || 'NA'}</div>
                    </div>
                    <div className="col-md-3">
                        <div className="fs-12 fw-600">Contact No.:</div>
                        <div className="fs-14">{candidateData?.phone || 'NA'}</div>
                    </div>
                    <div className="col-md-3">
                        <div className="fs-12 fw-600">Source:</div>
                        <div className="fs-14 lt-text-primary-alt">{mapPunchedByNameTextAndColor(candidateData?.dataPunchSource || 0).text}</div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    {loading ? (
                        <PageLoader />
                    ) : (
                        <>
                            <p className='fs-14 p-3 px-4 text-secondary d-none' dangerouslySetInnerHTML={{__html : candidateData?.matchDetails ?? ""}}>
                         
                            </p>
                            <hr />
                            {data && data.length > 0 && (
                                data.map((items, index) => (
                                    <div className="col-md-4" key={index}>
                                        <div className="match-cards mb-3">
                                            <div className="fs-12 mb-2 text-center fw-600">
                                                Candidate Status: <span className="lt-text-primary-alt">{candidateStatus(items?.candidateStatus)}</span>
                                            </div>
                                            <div className="d-flex justify-content-between fs-12 align-items-center">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="radio"
                                                        id={`matchCheck-${index}`}
                                                        name="matchRadio"
                                                        className="cursor-pointer"
                                                        checked={selectedRadioIndex === index}
                                                        onChange={() => {
                                                            setSelectedRadioIndex(index);
                                                            setFullName(items.fullName || '');
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor={`matchCheck-${index}`}
                                                        className="ms-1 cursor-pointer"
                                                    >
                                                        {items?.fullName || 'NA'}
                                                    </label>
                                                </div>
                                                <div>
                                                    {items.isFullNameMatching ? (
                                                        <span className="lt-text-success-alt">Match</span>
                                                    ) : (
                                                        <span className="lt-text-error">Mismatch</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between fs-12 align-items-center">
                                                <div className="text-crop">
                                                    <div
                                                        className="big-text"
                                                        style={{ top: '-9px' }}
                                                        title={items.email || 'NA'}
                                                    >
                                                        {items.email || 'NA'}
                                                    </div>
                                                </div>
                                                <div>
                                                    {items.isEmailMatching ? (
                                                        <span className="lt-text-success-alt">Match</span>
                                                    ) : (
                                                        <span className="lt-text-error">Mismatch</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between fs-12 align-items-center">
                                                <div>{items.phone || 'NA'}</div>
                                                <div>
                                                    {items.isPhoneNumberMatching ? (
                                                        <span className="lt-text-success-alt">Match</span>
                                                    ) : (
                                                        <span className="lt-text-error">Mismatch</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="text-center mt-2">
                                                <input
                                                    type="checkbox"
                                                    id={`mainMatchCheck-${index}`}
                                                    className="cursor-pointer"
                                                    checked={!!listCheckedMap[index]}
                                                    onChange={() => {
                                                        setListCheckedMap((prev) => ({
                                                            ...prev,
                                                            [index]: !prev[index],
                                                        }));
                                                        setUserData((prevUserData) => {
                                                            const alreadySelected = prevUserData.find(
                                                                (user) => user?.userId === items?.userId,
                                                            );
                                                            if (alreadySelected) {
                                                                return prevUserData.filter(
                                                                    (user) => user?.userId !== items?.userId,
                                                                );
                                                            } else {
                                                                return [...prevUserData, items];
                                                            }
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </>
                    )}
                </div>
            </Modal.Body>
            {showEventButton && showSidebarTab && (data && data.length > 0) && (
                <Modal.Footer className="justify-content-center">
                    <button
                        className="btn btn-outline-danger"
                        onClick={() => AcceptRejectCandidateMerge(MergeType.Reject)}
                    // disabled={!isAnyChecked || Object.keys(userData).length === 0}
                    >
                        Reject Match
                    </button>
                    <button
                        className="btn btn-outline-success"
                        onClick={() => AcceptRejectCandidateMerge(MergeType.Accept)}
                        disabled={!isAnyChecked || Object.keys(userData).length === 0}
                    >
                        Confirm Match
                    </button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default MatchModal;


const candidateStatus = (status: CandidateStatusEnum) => {

    switch (status) {
        case CandidateStatusEnum.Invited:
            return "Invited"
        case CandidateStatusEnum.Joined:
            return "Joined"
        case CandidateStatusEnum.Deleted:
            return "Deleted"
        case CandidateStatusEnum.Pending:
            return "Pending"
        case CandidateStatusEnum.Uploaded:
            return "Uploaded"
        case CandidateStatusEnum.ProvisionallyJoined:
            return "ProvisionallyJoined"
        default:
            return "NA"
    }

}